export enum FilterTypeRequest {
    FILIAL = 'FILIAL',
    UF = 'UF',
    MARCA = 'MARCA',
    DESCRICAO_ITEM = 'DESCRICAO_ITEM',
    BASE = 'BASE',
    BASE_DESC = 'BASE_DESC',
    BASE_CODE = 'BASE_CODE',
    CODIGO_ITEM = 'CODIGO_ITEM',
    CODIGO_FABRICANTE = 'CODIGO_FABRICANTE',
    CURVA_FAIXA = 'CURVA_FAIXA',
    LOCACAO = 'LOCACAO',
    LUCRATIVIDADE_FORNECEDOR = 'LUCRATIVIDADE_FORNECEDOR',
    STATUS = 'STATUS',
    ITEM_BLOQUEADO = 'ITEM_BLOQUEADO',
    ITEM_SALVO = 'ITEM_SALVO',
    ITEM_INTERCAMBIAVEL = 'ITEM_INTERCAMBIAVEL',
    DATA_ULTIMA_COMPRA = 'DATA_ULTIMA_COMPRA',
    DATA_ULTIMA_VENDA = 'DATA_ULTIMA_VENDA',
    PONTUACAO_ITEM = 'PONTUACAO_ITEM',
    ESTOQUE_DISPONIVEL = 'ESTOQUE_DISPONIVEL',
    DIAS_ESTOQUE_ATUAL = 'DIAS_ESTOQUE_ATUAL',
    DIAS_ESTOQUE_PENDENTE = 'DIAS_ESTOQUE_PENDENTE',
    DIAS_ESTOQUE_PROJECAO = 'DIAS_ESTOQUE_PROJECAO',
    DIAS_ESTOQUE_FUTURO = 'DIAS_ESTOQUE_FUTURO',
    PENDENCIA_ESTOQUE = 'PENDENCIA_ESTOQUE',
    COMPRA_UNIDADE = 'COMPRA_UNIDADE',
    PERCENTUAL_VARIACAO = 'PERCENTUAL_VARIACAO',
    MESES_ULTIMA_COMPRA = 'MESES_ULTIMA_COMPRA',
    MESES_ULTIMA_VENDA = 'MESES_ULTIMA_VENDA',
    QUANTIDADE_EXCESSO = 'QUANTIDADE_EXCESSO',
    ESTOQUE_POR_CUSTO_MEDIO = 'ESTOQUE_POR_CUSTO_MEDIO',
    MEDIA_FIXA = 'MEDIA_FIXA',
    CAMPANHAS_ATIVAS = 'CAMPANHAS_ATIVAS',
    PARAMETRO_MES = 'PARAMETRO_MES',
    OBSERVACAO_ITEM = 'OBSERVACAO_ITEM',
    VENDA_PERDIDA = 'VENDA_PERDIDA',
    OBSOLETO = 'OBSOLETO'
  }
